export const STORAGE_UTM_PARAMS_KEY = '@utm_params';
export const STORAGE_DEVICE_FINGERPRINT_ID_KEY = '@deviceFingerprintId';
